import axios from 'axios'
import token from '@/utils/token'
import store from '@/store/index'

const request = axios.create({
  baseURL: store.state.baseUrl
})
// 请求拦截器
request.interceptors.request.use(
  function (config) {
    const tokeninfo = token.gettoken('utoken')
    if (tokeninfo != null) {
      config.headers.token = tokeninfo
    }
    return config
  }
)
// 响应拦截器
request.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    return Promise.reject(error)
  }
)

export default request
